import { Component, OnInit, Input, ViewChild } from '@angular/core';

import { MarketService } from 'src/app/shared/services/market.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';


export interface Applications {
  propName: string;
  image_url: string
  status: string;
  propDescription: string
}

 const ELEMENT_DATA:Applications[] = [];

@Component({
  selector: 'app-view-sponsorship-applications',
  templateUrl: './view-sponsorship-applications.component.html',
  styleUrls: ['./view-sponsorship-applications.component.css']
})
export class ViewSponsorshipApplicationsComponent implements OnInit {
  displayedColumns: string[] = ['image_url', 'propName', 'status', 'propDescription'];
  dataSource = new MatTableDataSource(ELEMENT_DATA);

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  
  public pageName: string = "View";
  @Input() applicationInfo: any; 
  @Input() visible: boolean; 
  public displayDetails: boolean; 
  public _application: any;  
  categories = []; 

  public sp_application: any; 
  // public imageBaseUrl = "https://ganisponsormarket-all-purpose.s3.amazonaws.com/";
  imageBaseUrl = "https://cherymaupps3gradebookexample.s3.amazonaws.com/"

  constructor(private marketService: MarketService) { } 

  ngOnInit(): void {
    this.getSponsorshipApplications(); 

    this.categories = [
      { id: 1, value: 'SUBMITTED', isSelected: false },
      { id: 2, value: 'APPROVED', isSelected: false },
      { id: 3, value: 'REJECTED', isSelected: false }
    ];
  }

  getSponsorshipApplications() {
    console.log('getSponsorshipApplications called !!!');
    this.marketService.getSponsorshipApplications()
      .subscribe((data) => {
        console.log('Here is the data ==> ', data); 
        this.sp_application = data[0].Items; 

        this.dataSource = new MatTableDataSource(data[0].Items);

        this.dataSource.sort = this.sort;

        this.dataSource.paginator = this.paginator;
        console.log('sp_app ==> ', this.sp_application); 
      })
      err => {
        console.log('Err ==> ', err); 
      }
  }

  onDisplayDetails(applicationDetails: any) {
    this.displayDetails = true; 
    this._application = applicationDetails; 
    
  }

  clickable() {
    console.log('DIV has been clicked !!!'); 
  }

  clickablea() {
    console.log('A link has been clicked !!!'); 
  }

}
